module.exports = __webpack_public_path__ + "img/gfg.624bb9e8.svg";